var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointOfInterestHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#ffffff",
    stroke: "#8e24aa",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14) scale(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 20V8c4 0 5 10 10 10s6-10 10-10v12z",
    fill: "#8e24aa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointOfInterestHollow);
export default __webpack_public_path__ + "static/media/PointOfInterestHollow.3133b2adf286d6ea13caa924e2ac3c96.svg";
export { ForwardRef as ReactComponent };